import React from 'react';

interface InputIconProps {
  icon: React.ReactNode;
  position?: 'left' | 'right';
  onClick?: () => void;
}

export const InputIcon: React.FC<InputIconProps> = ({ 
  icon, 
  position = 'right',
  onClick 
}) => {
  const iconClasses = [
    'ui-input__icon',
    `ui-input__icon--${position}`,
    onClick && 'ui-input__icon--clickable'
  ].filter(Boolean).join(' ');

  return (
    <div className={iconClasses} onClick={onClick}>
      {icon}
    </div>
  );
};
